import utils from "../../../utils/utils";
import { DEFAULT_PRESETS } from "../../common/DateRangeFilter";

export const QMS_EMPTY_DATE_RANGE = {
  preset: "All Time",
  startDate: "",
  endDate: "",
};

export const QMS_COLUMN_DATE_PRESETS = DEFAULT_PRESETS;

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

function endOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

/** Client-side date-range match for ReportTable column filters. */
export function matchesQmsDateRange(value, range) {
  if (!range || range.preset === "All Time" || (!range.startDate && !range.endDate)) {
    return true;
  }
  const raw = String(value ?? "").trim();
  if (!raw || raw === "—" || raw.toUpperCase() === "N/A") return false;

  const date = utils.parseDateInput(raw);
  if (!date) return false;

  const startRaw = range.startDate ? utils.parseDateInput(range.startDate) : null;
  const endRaw = range.endDate ? utils.parseDateInput(range.endDate) : null;
  const start = startRaw ? startOfDay(startRaw) : null;
  const end = endRaw ? endOfDay(endRaw) : null;

  if (start && date < start) return false;
  if (end && date > end) return false;
  return true;
}
